import { basePaintProperty, 
        allLayersColorProperty, 
        paintProperties, 
        ColorAttributes } from "../../constants/constants";
import { calculateStatusColor,
        calculateAverageProgress, 
        calculateAverageDelay,
        calculatePaidPhysicalProgress, 
        calculateHistoricalObservations,
        calculateDates,
        whatsAppObservationFiltersPass} from "../cardsGroupsFeatures";

function getDataFromFeature(feature) {
    const figuregroupIds = [];
    let levelId = null;
    if (!feature.properties) return { figuregroupIds, levelId };
    
    if (feature.properties.figuregroup_id) {
        figuregroupIds.push(feature.properties.figuregroup_id);
        levelId = feature.properties.level_id;
    } else if (feature.properties.figuregroup_ids) {
        // Parse comma-separated string like ",123,456,"
        const idsStr = feature.properties.figuregroup_ids;
        const ids = idsStr
            .split(',')
            .filter(id => id !== '' && id !== null && id !== undefined)
            .map(id => {
                const parsed = parseInt(id.trim());
                return isNaN(parsed) ? null : parsed;
            })
            .filter(id => id !== null);
        figuregroupIds.push(...ids);
        levelId = feature.properties.level_id;
    }
    
    return { figuregroupIds, levelId };
}

function calculateWhatsAppObservationsColor(props, filters, feature, totalWhatsAppObservations) {
    // Obtener los figuregroup_ids y level_id de la feature
    const { figuregroupIds, levelId } = getDataFromFeature(feature);
    // Si no hay figuregroup_ids, retornar null
    if (figuregroupIds.length === 0) {
        return null;
    }
    
    const whatsappObservations = props.whatsappObservations.observations || {};
    const whatsappFilters = props.whatsappObservations?.filters || {};
    
    // Contar cuántas observaciones tiene esta feature
    let featureObservationsCount = 0;
    
    for (const figuregroupId of figuregroupIds) {
        // Iterar sobre todas las observaciones
        for (const key in whatsappObservations) {
            const observationData = whatsappObservations[key];
            // console.log("observationData", observationData)
            // Verificar si la observación pasa los filtros
            // if (!whatsAppObservationFiltersPass(whatsappFilters, observationData)) {
            //     continue;
            // }
            // console.log("whatsAppObservationFiltersPass")
            
            // Verificar si esta observación tiene el figuregroupId y levelId en sus locations
            if (observationData.locations && Array.isArray(observationData.locations)) {
                if (observationData.locations.some(location => 
                    location.figuregroup_id === figuregroupId && location.level_id === levelId)) {
                    featureObservationsCount++;
                }
            }
        }
    }
    
    // Calcular el total de observaciones que pasan los filtros
    // let totalObservations = 0;
    // for (const key in whatsappObservations) {
    //     const observationData = whatsappObservations[key];
    //     // if (whatsAppObservationFiltersPass(whatsappFilters, observationData)) {
    //     //     console.log("whatsAppObservationFiltersPass2")
    //     // }
    //     console.log("whatsAppObservationFiltersPass2")
    //     totalObservations++;
    // }
    // console.log("totalObservations", totalObservations)
    
    // Si no hay observaciones totales, retornar null
    if (totalWhatsAppObservations === 0) {
        return null;
    }
    
    // Si la feature no tiene observaciones, retornar null
    if (featureObservationsCount === 0) {
        return null;
    }
    
    // Calcular el porcentaje (0-1)
    const percentage = featureObservationsCount / totalWhatsAppObservations;
    
    // Interpolar el color rojo basado en el porcentaje
    // Rojo claro: rgb(255, 200, 200) para porcentajes bajos
    // Rojo intenso: rgb(255, 0, 0) para porcentajes altos
    // Usamos una escala logarítmica para mejor visualización de diferencias pequeñas
    
    // Normalizar el porcentaje con escala logarítmica para mejor diferenciación
    const normalizedPercentage = Math.min(1, Math.log10(percentage * 100 + 1) / 2);
    
    // Calcular los componentes RGB
    const red = 255;
    const green = Math.round(200 * (1 - normalizedPercentage));
    const blue = Math.round(200 * (1 - normalizedPercentage));
    
    // Retornar el color en formato rgb
    return `rgb(${red}, ${green}, ${blue})`;
}

function getPaintProperty(featureAttribute) {
    const paintProperty = paintProperties[featureAttribute];
    return [...basePaintProperty, paintProperty];
}

function setFeaturesColor(map, props, featureAttribute) {
    for (const [levelId, featuresGroup] of Object.entries(props.featuresGroups)) {
        if (props.filters.levelIds.length > 0 && !props.filters.levelIds.includes(parseInt(levelId))) continue;
        let stageId = props.projectData.levels[levelId].attributes.stage_id;
        if (props.filters.stageIds.length > 0 && !props.filters.stageIds.includes(stageId)) continue;
        for (const feature of featuresGroup) {
            setFeatureColor(map, props, feature, featureAttribute);
        }
    }
}

function setFeatureColor(map, props, feature, featureAttribute) {
    let stateValue = null;
    if (props.whatsappObservationsMode) {
        const totalWhatsAppObservations = Object.keys(props.whatsappObservations.observations).length;
        stateValue = calculateWhatsAppObservationsColor(props, map.filters, feature, totalWhatsAppObservations);
    } else {
        if (featureAttribute === ColorAttributes.STATUS) {
            stateValue = calculateStatusColor(props, map.filters, feature);
        } else if (featureAttribute === ColorAttributes.PROGRESS) {
            stateValue = calculateAverageProgress(props, map.filters, feature);
        } else if (featureAttribute === ColorAttributes.DELAYED) {
            stateValue = calculateAverageDelay(props, map.filters, feature);
        } else if (featureAttribute === ColorAttributes.PAID_PHYSICAL_PROGRESS) {
            stateValue = calculatePaidPhysicalProgress(props, map.filters, feature);
        } else if (featureAttribute === ColorAttributes.HISTORICAL_OBSERVATIONS) {
            stateValue = calculateHistoricalObservations(props, map.filters, feature);
        } else if (featureAttribute === ColorAttributes.DATES) {
            stateValue = calculateDates(props, map.filters, feature);
        }
    }
    map.setFeatureState({ 
        id: feature.id,
        source: 'cards'
    }, { 
        [featureAttribute]: stateValue 
    });
}

export function handleFeaturesPaint(map, props, featureAttribute) {
    const effectiveFeatureAttribute = props.whatsappObservationsMode 
        ? ColorAttributes.WHATSAPP_OBSERVATIONS
        : featureAttribute;
    const paintProperty = getPaintProperty(effectiveFeatureAttribute);
    for (const [layer, color] of Object.entries(allLayersColorProperty)) {
        map.setPaintProperty(layer, color, paintProperty);
    }
    if (effectiveFeatureAttribute !== ColorAttributes.CARD_CATEGORY) {
        setFeaturesColor(map, props, effectiveFeatureAttribute);
    }
}